export const productFilter = {
  computed: {
    query() {
      return this.$route.query;
    },
    brandId() {
      return this.query.b;
    },
    search: {
      get() {
        return this.query.q || "";
      },
      set(v) {
        const query = { ...this.query };
        if (v) query.q = v;
        else delete query.q;

        delete query.p;

        const path = ["/produtos"].includes(this.$route.path)
          ? this.$route.path
          : "/produtos";

        this.$router.push({ path, query });
      },
    },
    categoriesSelecteds: {
      get() {
        return parseInt(this.query.c) || null;
      },
      set(v) {
        const query = { ...this.query };
        if (v) query.c = v;
        else delete query.c;

        this.$router.push({ query });
      },
    },
    subCategoriesSelecteds: {
      get() {
        return parseInt(this.query.sc) || null;
      },
      set(v) {
        const query = { ...this.query };
        if (v) query.sc = v;
        else delete query.sc;

        this.$router.push({ query });
      },
    },
  },
};
